import {Locale} from "@js-joda/locale_en-us";
import {DateIOFormats, Unit} from "@date-io/core/IUtils";
import AdapterJoda from "@date-io/js-joda";
import {LocalDate, LocalDateTime, ZonedDateTime} from "@js-joda/core";

type CalendarType = LocalDateTime | LocalDate | ZonedDateTime;

export class CustomAdapter extends AdapterJoda {
	constructor(options: { formats?: Partial<DateIOFormats>; locale?: Locale } = {}) {
		super(options);
		const getDiff = this.getDiff;
		this.getDiff = (value: CalendarType, comparing: string | CalendarType, unit?: Unit | undefined) => {
			// there is a bug in the AdapterJoda.getDiff()
			// Error: Unable to obtain LocalDateTime TemporalAccessor: 2022-12-31, type LocalDate
			// it is caused by trying to get the difference between the old value and the new value in seconds
			// when one of the values is a LocalDate
			// since LocalDate does not have time data, this throws an exception
			if (unit === "hours" ||
				unit === "minutes" ||
				unit === "seconds" ||
				unit === "milliseconds") {
				
				if (value instanceof LocalDate)
					value = value.atTime(0, 0);
				
				if (comparing instanceof LocalDate)
					comparing = comparing.atTime(0, 0);
			}
			return getDiff(value, comparing, unit);
		};
	}
}
